import React from 'react'
import CTAButton from '../CTA/cta'
import Markdown from '../Markdown/markdown'
import './vertical-grid.scss'

class VerticalGrid extends React.Component {

  renderGridItems(gridItems) {
    if (gridItems) {
      return (
        <div className="vgrid-container">
          {gridItems.map((item, i) => { 
            const bgColor = item.backgroundColor ? {backgroundColor: item.backgroundColor} : {}
            return <div className={`grid-item`} key={i} style={bgColor}>{this.renderItem(item)}</div> })}
        </div>
      )
    } else {
      return null
    }
  }

  renderItem(item) {
    if (item) {
      
      const ctas = item.ctaButtons ? item.ctaButtons.map((cta, i) => {
        const url = cta.url
        const style = cta.style
  
        return (
          <div className="button-container" key={ i }>
            <CTAButton title={ cta.title } url={ url } style={ style }/>
          </div>
        )
      }) : []

      return (
        <React.Fragment>
          <h3>{item.heading}</h3>
          {item.body && item.body.body ? <div className={`grid-item-body`}>
            <Markdown content={item.body.body} /></div> : null
          }
          { ctas.length > 0 ? 
            <div className="button-container">
              { ctas }
            </div> : null }
        </React.Fragment>
      )
    }
  }

  render() {
    const {gridItems} = this.props.content
    
    return (
      <div className='grid-wrapper'>
        {this.renderGridItems(gridItems)}
      </div>
    )
  }
}

export default VerticalGrid;


// WEBPACK FOOTER //
// ./src/components/VerticalGrid/vertical-grid.js